import { useFetchUserSettings } from '@/hooks';
import { createContext, ReactNode, useContext } from 'react';
import { useAuth } from './AuthContext';

interface UserSettings {
    timezone: string;
}

interface ContextProps {
    children: ReactNode;
}

const defaultUserSettings: UserSettings = {
    timezone: 'UTC',
};

const UserSettingsContext = createContext<UserSettings>(defaultUserSettings);

const UserSettingsProvider = ({ children }: ContextProps) => {
    const { isAuthenticated } = useAuth();

    const { data } = useFetchUserSettings(isAuthenticated);

    const value: UserSettings = {
        timezone: data?.timezone || 'UTC',
    };

    return <UserSettingsContext.Provider value={value}>{children}</UserSettingsContext.Provider>;
};

export default UserSettingsProvider;

export const useUserSettings = () => useContext(UserSettingsContext);
